export default {
  COMMON__MINUTES: '분',
  SENDBIRD: {
    BADGE__OVER: '+',
    MESSAGE_MENU__EDIT: '수정',
    BUTTON__DELETE: '삭제',
    MESSAGE_STATUS__DELETE: '삭제',
    MESSAGE_MENU__DELETE: '삭제',
    BUTTON__SAVE: '저장',
    BUTTON__CANCEL: '취소',
    BUTTON__CLOSE: '닫기',
    MODAL__CHANNEL_INFORMATION__UPLOAD: '업로드',
    EDIT_PROFILE__IMAGE_UPLOAD: '업로드',
    CHANNEL_LIST__TITLE: '채널',
    CHANNEL_SETTING__HEADER__TITLE: '채널 정보',
    MODAL__USER_LIST__TITLE: '멤버',
    CHANNEL_SETTING__MEMBERS__TITLE: '멤버',
    NO_MEMBERS: '(빈 채널)',
    NO_NAME: '(알 수 없는 사용자)',
    TOOLTIP__UNKOWN_USER: '(알 수 없는 사용자)',
    CHANNEL_SETTING__LEAVE_CHANNEL__TITLE: '채널 나가기',
    BUTTON__INVITE: '초대',
    MODAL__INVITE_MEMBER__SELECTED: '선택됨',
    MODAL__CREATE_CHANNEL__SELECTED: '선택됨',
    MODAL__CHANNEL_INFORMATION__CHANNEL_NAME: '채널명',
    MODAL__INVITE_MEMBER__TITLE: '멤버 추가',
    CHANNEL__MESSAGE_INPUT__PLACE_HOLDER: '입력하세요',
    MESSAGE_INPUT__PLACE_HOLDER: '입력하세요',
    BUTTON__CREATE: '만들기',
    MODAL__CREATE_CHANNEL__TITLE: '새 채널',
    TRYING_TO_CONNECT: '연결을 시도중입니다...',
    USER_PROFILE__MESSAGE: '메시지',
    USER_PROFILE__USER_ID: '사용자 ID',
    EDIT_PROFILE__USERID_LABEL: '사용자 ID',
    EDIT_PROFILE__TITLE: '내 프로필',
    EDIT_PROFILE__IMAGE_LABEL: '프로필 이미지',
    EDIT_PROFILE__NICKNAME_LABEL: '닉네임',
    EDIT_PROFILE__THEME_LABEL: '다크 테마',
    CHANNEL__MESSAGE_INPUT__PLACE_HOLDER__DISABLED: '이 채널에서 채팅을 할 수 없습니다',
    CHANNEL__MESSAGE_LIST__NOTIFICATION__NEW_MESSAGE: '여기까지 읽음',
    CHANNEL__MESSAGE_LIST__NOTIFICATION__ON: '활성',
    CHANNEL_SETTING__MEMBERS__SEE_ALL_MEMBERS: '전체 멤버',
    CHANNEL_SETTING__MEMBERS__INVITE_MEMBER: '사용자 초대',
    MODAL__DELETE_MESSAGE__TITLE: '이 메시지를 삭제하시겠습니까?',
    MODAL__CHANNEL_INFORMATION__TITLE: '채널 정보 편집',
    MODAL__CHANNEL_INFORMATION__CHANNEL_IMAGE: '채널 이미지',
    MODAL__CHANNEL_INFORMATION__INPUT__PLACE_HOLDER: '이름을 입력하세요',
    TYPING_INDICATOR__IS_TYPING: '입력 중입니다...',
    TYPING_INDICATOR__ARE_TYPING: '입력 중입니다...',
    TYPING_INDICATOR__MULTIPLE_TYPING: '입력 중입니다...',
    TYPING_INDICATOR__AND: '그리고',
    MESSAGE_STATUS__SENDING_FAILED: '메시지를 전송할 수 없습니다.',
    MESSAGE_STATUS__TRY_AGAIN: '다시 시도해주세요',
    MESSAGE_STATUS__OR: '또는',
    PLACE_HOLDER__WRONG: '오류가 발생했습니다.',
    PLACE_HOLDER__RETRY_TO_CONNECT: '재시도',
    NO_TITLE: '제목 없음',
    TOOLTIP__AND_YOU: ', 그리고 나',
    TOOLTIP__YOU: '나',
    UNKNOWN__UNKNOWN_MESSAGE_TYPE: '(알 수 없는 메시지)',
    UNKNOWN__CANNOT_READ_MESSAGE: '이 메시지를 읽을 수 없습니다.',
    MESSAGE_EDITED: '(편집됨)',
    PLACE_HOLDER__NO_CHANNEL: '새로운 대화를 시작해보세요',
    MESSAGE_MENU__REPLY: '답장',
    QUOTED_MESSAGE__REPLIED_TO: '→',
    QUOTE_MESSAGE_INPUT__REPLY_TO: '',
    QUOTED_MESSAGE__CURRENT_USER: '나',
    MESSAGE_INPUT__QUOTE_REPLY__PLACE_HOLDER: '답장 쓰기',
    CHANNEL_SETTING__PROFILE__EDIT: '편집',
    MESSAGE_MENU__COPY: '복사',
  },
  TERMS_IMPRESSUM: 'Impressum',
  TERMS_DATENSCHUTZ: 'Datenschutz',
  CONFIRM: '확인',
  SETTINGS__NONE: '없음',
  SEARCH__USER_PLACEHOLDER: '이름/사번/휴대폰 번호로 검색',
  SEARCH__NO_USER_INFO: '사용자 정보가 없습니다.',
  LOGIN__EMAIL_OR_HP: '이메일 또는 휴대폰 번호',
  ELECTRON: {
    MENU_DELETE: '삭제',
    MENU_VIEW: '보기',
    MENU_SIGN_OUT: '로그아웃',
    MENU_SETTINGS: '설정',
    MENU_CLOSE: '닫기',
    MENU_SELECT_ALL: '전체 선택',
    MENU_FILE: '파일',
    MENU_ABOUT: '{0} 정보',
    MENU_UPDATE: '업데이트 확인',
    MENU_HIDE: '{0} 숨기기',
    MENU_HIDE_OTHERS: '다른 앱 숨기기',
    MENU_SHOW_ALL: '모두 보여주기',
    MENU_QUIT: '{0} 종료',
    MENU_NEW_CHANNEL: '새 채널',
    MENU_UNDO: '실행 취소',
    MENU_REDO: '다시 실행',
    MENU_CUT: '잘라내기',
    MENU_PASTE: '붙여넣기',
    MENU_PASTE_AND_MATCH_STYLE: '스타일 붙여넣기',
    MENU_RELOAD: '다시 불러오기',
    MENU_FORCE_RELOAD: '강제 불러오기',
    MENU_FULL_SCREEN: '전체 화면으로 전환',
    MENU_RESET_ZOOM: '실제 크기',
    MENU_ZOOM_IN: '확대',
    MENU_ZOOM_OUT: '축소',
    MENU_WINDOW: '창',
    MENU_MINIMIZE: '최소화',
    MENU_ZOOM: '최대화',
    MENU_HELP: '도움말',
    MESSAGE_UP_TO_DATE: '현재 최신 버전을 사용 중입니다.',
    UPDATE_AVAILABLE: '업데이트 가능',
    MESSAGE_UPDATE_AVAILABLE: '최신 버전으로 업데이트 할 수  있습니다.',
    MENU_EDIT: '편집',
    MENU_COPY: '복사',
    UP_TO_DATE: '최신 버전',
  },
  LOGIN__INSERT_EMAIL_HP: '이메일 또는 휴대폰 번호를 입력해주세요.',
  LOGIN__PASSWORD_GUIDE_SUBTITLE:
    '비밀번호가 기억나지 않을 경우 모바일앱 로그인 페이지에서 비밀번호를 재설정해 보세요.',
  LOGIN__INSERT_PASSWORD: '비밀번호를 입력해주세요.',
  LOGIN__PASSWORD_INFORMATION: '비밀번호가 기억나지 않으세요?',
  BEFORE: '기존',
  ALERT__NO_ONE_SELECTED: '선택된 인원이 없습니다.',
  BASIC__: {
    ERROR: '에러가 발생하였습니다.<br /> 잠시 후 다시 시도해보세요.',
    MSG__: { INPUT: '검색어를 입력하세요' },
    PWD_ALL_VALIDATION: '%1$@~%2$@자의 영문 대소문자, 숫자, 특수문자를 조합하여 설정해주세요.',
    RETRY: '재시도',
    PASSWORD_RULE: '8-20자 영문 대소문자, 숫자, 특수문자 조합',
    HAS_ATTENDANCE_HISTORY_VIEW_RIGHT: '본인 출퇴근 이력 조회 권한',
  },
  LOGOUT: '로그아웃',
  COMMON__SECONDS: '초',
  SCHEDULE__: {
    GUIDE__: {
      IF_YOU_STOP_UNSAVED: '편집을 중단할 경우 수정된 내용은 저장되지 않습니다.',
      ARE_YOU_SURE_WANT_TO_STOP: '스케줄 편집을 중단 하시겠습니까?',
    },
  },
  TEMPLATE__: { GUIDE__: { NO_TEMPLATE_REGISTERED: '등록된 템플릿이 없습니다.' } },
  AWAY_TIME: '시',
  SETTINGS__CHANGE_LANGUAGE: '언어 설정',
  SEARCH__MEMBER_PLACEHOLDER: '이름/사번/휴대폰 번호',
  ' ': '사용 안 함으로 설정할 경우 임산부 관리 기능이 비활성화 되고, 관련 기록을 조회할 수 없습니다.',
  BASIC__UNKNOWN: '알 수 없음',
  LOGIN__SERVER_ALERT: '서버에 연결할 수 없습니다.',
  MSG__: {
    ERROR__: {
      UPDATE_CHANNEL_INFO: '채널 정보를 업데이트 할 수 없습니다.',
      LEAVE_CHANNEL: '채널을 나갈 수 없습니다.',
      CREATE_CHANNEL: '채널을 개설할 수 없습니다.',
    },
    FILE__: { MAXIMGSIZE: '최대 파일 사이즈 25MB를 초과하였습니다.' },
    ALLOW_BROWSER_ALARM: '브라우저 설정에서 알림을 허용해야 알림 메시지를 확인할 수 있습니다.',
    LABEL__: { SEARCH_MESSAGE: '메시지 검색' },
    GUIDE__: { SEARCH_MESSAGE: '{0}에서 찾고 싶은 메시지 내용을 검색하세요.' },
    BASIC__: { NO_SEARCH_RESULT: '결과가 없습니다.' },
  },
  INVITE__MEMBER_SELECTION: '멤버 선택',
  CHANNEL__EDIT_CHANNEL_NAME_GUIDE: '변경된 이름은 모든 채널 멤버에게 보여집니다.',
  NOTICE: '알림',
  INVITE__CREATE: '만들기',
  CHANNEL__LEAVE_THIS_CHANNEL: '채널을 나가시겠습니까?',
  LOGIN__PASSWORD_FAIL_COUNT: '비밀번호가 {0}회 틀렸습니다.',
  LOGIN__FAIL_ALERT: '5회 연속 틀릴 경우 5분간 잠금 상태가 됩니다.',
  LOGIN__LOCK_STATE_ALERT: '비밀번호가 연속으로 틀려 5분간 잠금 상태가 되었습니다.',
  LOGIN__RETRY_ALERT: '{0} 후에 다시 시도하세요.',
  LOGIN__PASSWORD_GUIDE_TITLE: 'ShoplChat 비밀번호는 모바일앱 비밀번호와 동일합니다.',
  SETTINGS__ALL_MESSAGES: '모든 새 메시지에 알림',
  SETTINGS__ALARM_SOUND: '소리',
  SETTINGS__SOUND_ALARM: '알림음',
  SETTINGS__LISTEN_ALARM_SOUND: '듣기',
  ALERT__MAX_INVITE_MEMBER: '채널에 참여할 수 있는 최대 인원 수는 20,000명입니다.',
  LOGIN__DEACTIVATED_ALERT: '관리자가 채팅 기능을 비활성화하여, 로그인 할 수 없습니다.',
  LOGIN__SERVER_ALERT_CONTENTS: '네트워크가 불안정하여 로그인할 수 없습니다. 인터넷 연결을 확인하고 다시 시도해보세요.',
  LOGIN__LOGOUT_ALERT: '로그아웃 되었습니다.',
  CHANNEL__EDIT_CHANNEL_NAME: '채널명 변경',
  SETTINGS__THEME: '테마',
  SETTINGS__LANGUAGE: '언어',
  SETTINGS__LIGHT_THEME: '라이트',
  SETTINGS__DARK_THEME: '다크',
  SEARCH__CHANNEL_PLACEHOLDER: '직원이름',
  CHANNEL__CONTACT: '1:1 채팅',
  BASIC: { LABEL: { MAXIMAGECNT: '이미지는 최대 {0}개까지 등록할 수 있습니다.' } },
  LOGIN__LOGIN_FAILED: '아이디 또는 비밀번호가 일치하지 않습니다.',
  FORGOT_PW: '비밀번호를 잊으셨나요?',
  BASIC__MAX_FORMAT_INPUT: '최대 %@자까지 입력할 수 있습니다.',
  SERVICE__COMING_SOON: '곧 제공 예정입니다',
  LOGIN__GUIDE: '앱에서 사용하는 계정으로 로그인이 가능합니다.',
  MOBILE__: {
    ACCESS_PC: '대시보드는 PC에서 접속해주세요!',
    ACCESS_DESC_01: '대시보드는 PC 환경에 최적화되어 있습니다.',
    ACCESS_DESC_02: '원활한 사용을 위해 PC에서 접속해주세요.',
    ACCESS_PC_ONLY: 'PC에서 접속해주세요.',
    GUIDE: '채팅 기능은 PC 또는 모바일 앱에서 사용할 수 있습니다.',
  },
  CHANNEL__NO_CHAT_HISTORY: '대화 내역이 없습니다',
  LOGIN: '로그인',
  LOGIN__PASSWORD: '비밀번호',
  SEARCH__NO_RESULT: '결과가 없습니다.',
  BASIC__SEARCH: '검색',
};
